export const formatCurrencyTable = (value) => {
  const num = Number(value);

  if (isNaN(num)) return "0,00";

  return num
    .toFixed(2) // 2 decimales
    .replace(".", ",") // coma decimal
    .replace(/\B(?=(\d{3})+(?!\d))/g, "."); // puntos de miles
};
